import { h } from 'preact'
import Tooltip from '../ui-components/Tooltip'
import Icon from '../assets'
import { Loader } from './Loader'

interface KeyInsightCardProps {
    title: string,
    titleTooltip?: string,
    comparisionTooltip?: string,
    total?: number | string,
    showComparisionUnavailable?: boolean,
    percent?: number,
    hideComparisionWithPreviousPeriod?: boolean,
    isPercentage?: boolean,
    isLoading: boolean,
    isKeyInsightAvailable?: boolean,
    keyInsightUnavailableMessage?: string
}

function isNumeric (val: any): boolean {
  return !(val instanceof Array) && (val - parseFloat(val) + 1) >= 0
}

export const KeyInsightCard = ({ title, total, percent, titleTooltip, comparisionTooltip, isLoading, isPercentage = false, hideComparisionWithPreviousPeriod = false, showComparisionUnavailable = false, isKeyInsightAvailable = true, keyInsightUnavailableMessage }: KeyInsightCardProps) => {
  const isNegative = percent && percent < 0
  const noChange = percent?.toFixed().replace('-0', '0') === '0'
  let value = total
  if (isNumeric(total)) {
    total = Number(total)
    value = isPercentage ? (Number.isInteger(total) ? `${total}%` : `${total?.toFixed(2)}%`) : total
  }
  return (
    <div className='metric-summary-wrapper'>
      <div className='metric-summary'>
        <div className='metric-header'>
          <div className='metric-title'>{title}
            {titleTooltip && <Tooltip
              position='left'
              trigger={<Icon icon='question' width={16} height={16} customClass='icon-info' />}
              customClasses='metric-help-tooltip'
              tooltipMessage={titleTooltip}
            />}
          </div>
        </div>
        {isLoading ? <Loader />
          : !isKeyInsightAvailable ? <div className='metric-data-not-tracked-text'>{keyInsightUnavailableMessage} </div>
            : <div className='metric-additional-data'>
              <div className='metric-count'>{value}</div>
              {hideComparisionWithPreviousPeriod ? null
                : <div className='metric-comparision'>
                  { showComparisionUnavailable ? <div className='metric-percentage metric-text'> - </div>
                    : noChange ? <div> 0% </div>
                      : <div className={`metric-percentage ${isNegative ? 'metric-percentage-negative' : 'metric-percentage-positive'}`}>
                        {!isNegative && '+'}{percent?.toFixed()}%
                      </div>}
                  <div className='metric-text'>vs previous period
                    {comparisionTooltip && <Tooltip position='left'
                      trigger={<Icon width={16} height={16} icon={'question'} customClass='icon-previous-period-info' />}
                      customClasses='metric-help-tooltip'
                      tooltipMessage={comparisionTooltip} />}
                  </div>
                </div>}
            </div>}
      </div>
    </div>)
}
